module.exports = __webpack_public_path__ + "img/back1.b9043e4c.png";